module.exports = __webpack_public_path__ + "static/media/chevron-down.96b2bf97.svg";